import { Slider, Tooltip } from 'antd';
import { forwardRef, useEffect, useState } from 'react';
import numeral from 'numeral';
import Styles from './index.module.scss';
import Image from 'next/image';
import { useImperativeHandle } from 'react';
const play = '/img/products/vod-assessment/videoIcons/play.webp';
const volumeImg = '/img/products/vod-assessment/videoIcons/volume.webp';
const pause = '/img/products/vod-assessment/videoIcons/pause.webp';
const volumeMute = '/img/products/vod-assessment/videoIcons/volumeMute.webp';
const fullScreen = '/img/products/vod-assessment/videoIcons/fullScreen.webp';

interface IProps {
  video: any;
  currentTime: number;
  duration: number;
  playOrPause: Function;
  requestFullScreen: Function;
  volumeChange: Function;
  muted?: boolean;
  seek: Function;
}

function timeFormat(val) {
  return numeral(val).format('00:00:00');
}

export enum VideoStatus {
  played = 'played',
  paused = 'paused',
}
export enum VideoVolumeOperations {
  status = 'status',
  value = 'value',
}

const Control = (
  {
    video,
    currentTime,
    duration,
    playOrPause,
    requestFullScreen,
    volumeChange,
    muted,
    seek,
  }: IProps,
  ref
) => {
  const [videoStatus, setVideoStatus] = useState(VideoStatus.paused);
  const toggleVideo = () => {
    const res = playOrPause();
    setVideoStatus(res);
  };

  useImperativeHandle(ref, () => {
    return {
      setVideoStatus: (val) => setVideoStatus(val),
    };
  });

  // 播放结束后，自动暂停
  //seek 后也会触发该方法，此时ended 为 false
  useEffect(() => {
    if (video?.ended) {
      setVideoStatus(VideoStatus.paused);
    }
  }, [video?.ended]);
  const [sliderValue, setSliderValue] = useState(0);
  useEffect(() => {
    setSliderValue((currentTime / duration) * 100);
  }, [currentTime]);

  // 音量控制
  const [volume, setVolume] = useState(30);
  const VolumeComponent = () => {
    return (
      <span className={Styles.volumeControl}>
        <Slider onChange={(val) => onVolumeChange(val)} value={volume} />
      </span>
    );
  };
  const onVolumeChange = (val: number) => {
    // 0 - 100
    if (val) {
      // val > 0 时，表示设置音量，val = 0 时，表示设置静音
      setVolume(val);
    }
    volumeChange(val / 100);
  };

  return (
    <div className={Styles.control}>
      <div className={Styles.operationContainer}>
        <span>
          <Image
            className={Styles.operationIcon}
            src={videoStatus === VideoStatus.played ? play : pause}
            width={18}
            height={18}
            alt="paly/pause"
            onClick={toggleVideo}
            crossOrigin="anonymous"
            style={{
              maxWidth: '100%',
              height: 'auto',
            }}
          />
          <span style={{ marginLeft: 12 }}>
            {timeFormat(currentTime)} / {timeFormat(duration)}
          </span>
        </span>
        <span>
          <span className={Styles.volumeContainer}>
            <VolumeComponent />
            <Image
              className={Styles.operationIcon}
              src={muted || video?.volume === 0 ? volumeMute : volumeImg}
              width={18}
              height={18}
              alt="volume"
              onClick={() =>
                onVolumeChange(muted || video?.volume === 0 ? volume : 0)
              }
              crossOrigin="anonymous"
              style={{
                maxWidth: '100%',
                height: 'auto',
              }}
            />
          </span>
          <Image
            className={Styles.operationIcon}
            src={fullScreen}
            width={14}
            height={14}
            alt="fullScreen"
            onClick={() => requestFullScreen()}
            crossOrigin="anonymous"
            style={{
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </span>
      </div>
      <div className={Styles.bar}>
        <Slider
          value={sliderValue}
          onChange={(val) => {
            setSliderValue(val);
            seek((val * duration) / 100);
          }}
          tipFormatter={null}
        />
      </div>
    </div>
  );
};

export default forwardRef(Control);
